import UserScreenWindow from "../Components/UserScreenWindow";
import Select from "react-select";
import { useEffect, useState } from "react";
import {
  getDocDataSnap,
  storage,
  setDocData,
} from "../../../utils/firebase/Firebase.utils";
import { useSelector } from "react-redux";
import { v4 } from "uuid";
import { useNavigate } from "react-router-dom";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useSearchParams } from "react-router-dom";
import FileUploadAndView from "../Components/FileUploadAndView";
import {
  FaHardHat,
  FaBuilding,
  FaTools,
  FaCalendarAlt,
  FaUsers,
  FaTruck,
  FaMoneyBillWave,
  FaFileAlt,
  FaInfoCircle,
  FaClock,
  FaMapMarkerAlt,
  FaCarAlt,
  FaPaperPlane,
  FaShieldAlt,
  FaPlus,
  FaSearch,
  FaShareAlt,
} from "react-icons/fa";
import { dualNotification } from "../../../utils/EleghoUtils";
import { useCompany } from "../../../context/CompanyContext";
import { adminEmailAddress, unitNumberLabel } from "../../../utils/constants";
import InputBox from "../../Dashboard/Components/InputBox";
import { FaLocationPin } from "react-icons/fa6";

function WorkPermitUser() {
  const { companyData } = useCompany();

  const [searchParams, setSearchParams] = useSearchParams();

  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("details");

  const { getCapitalizedTerm } = useCompany();

  const id = searchParams.get("continue");

  const [formData, setFormData] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const [identifiers, setIdentifiers] = useState([]);
  const [files, setFiles] = useState({});
  const [assignedId, setAssignedId] = useState(
    id ? id : v4().slice(0, 8).toUpperCase()
  );
  const [progress, setProgress] = useState(0);
  const [url, setUrl] = useState("");
  const [activeUpload, setActiveUpload] = useState(false);
  const navigate = useNavigate();

  const currentUser = useSelector((state) => state.userObject);

  useEffect(() => {
    const getUser = async () => {
      const userSnap = getDocDataSnap("users", currentUser.uid, (data) => {
        setIdentifiers(data.linkedIdentifiers);
      });
    };
    getUser();
  }, []);

  useEffect(() => {
    const fetchRequest = async () => {
      const data = await getDocDataSnap("workPermits", assignedId, (data) => {
        setFormData(data);
        setFiles(data.files || {});
        setIsLoading(false);
      });
    };

    if (id) {
      fetchRequest();
    } else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return (
      <UserScreenWindow label="Work Permit Request">
        <div className="flex justify-center items-center h-screen">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#363062]"></div>
        </div>
      </UserScreenWindow>
    );
  }

  const options = [
    { value: "minor renovation", label: "Minor Renovation" },
    { value: "major renovation", label: "Major Renovation" },
    // { value: "construction", label: "Construction" },
  ];

  const identifierOptions =
    identifiers?.map((id) => ({
      value: id,
      label: id,
    })) || [];

  const handleSelect = (e, name) => {
    setFormData({ ...formData, [name]: e.value });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSettingFileList = (e, fileName) => {
    setFiles([...files, { name: fileName, file: e.target.files[0] }]);
  };

  const handleUpload = (e, fileName) => {
    const file = e.target.files[0];
    const storageRef = ref(storage, `workPermits/${assignedId}/${fileName}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    setActiveUpload(fileName);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
      },
      (error) => {},
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setUrl(downloadURL);
          setFiles({
            ...files,
            [fileName]: downloadURL,
          });
          setActiveUpload(false);
        });
      }
    );
  };

  const handleSubmit = async () => {
    setIsProcessing(true);
    const docObject = {
      ...formData,
      status: "Pending",
      name: currentUser.displayName,
      files: files,
      createdAt: new Date().toLocaleString(),
      createdBy: currentUser.email,
      userId: currentUser.uid,
      user: currentUser.email,
      id: assignedId,
    };

    await setDocData("workPermits", assignedId, docObject);

    const notificationObject = {
      recipient: adminEmailAddress,
      recipientName: "Admin",
      sender: currentUser.email,
      senderName: currentUser.displayName,
      type: "work-permit",
      subject: "New Work Permit Request",
      message: `A new work permit request has been submitted by ${currentUser.displayName} of ${formData.identifier}.`,
      url: `/work-permit/${assignedId}`,
      id: assignedId,
      dateTime: new Date(),
      read: "false",
    };

    await dualNotification(notificationObject);

    navigate("/work-permit-confirmation/" + assignedId);
  };

  return (
    <UserScreenWindow label="Work Permit Request">
      <div className="w-full mx-auto px-3 pb-20">
        {/* Header */}
        <div className="flex items-center justify-between mb-6 bg-[#363062]/5 p-4 rounded-lg">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-[#363062] rounded-lg">
              <FaHardHat className="text-white text-base" />
            </div>
            <div>
              <h1 className="text-sm font-medium text-[#363062]">
                Work Permit Request
              </h1>
              <p className="text-xs text-gray-500">
                Submit your work permit applications
              </p>
              <p className="text-xs text-gray-500 mt-0.5">Ref: {assignedId}</p>
            </div>
          </div>
        </div>

        {/* Form Fields */}
        <div className="space-y-4 mt-4 bg-white p-4 rounded-lg shadow-md">
          {/* Work Type */}
          <div className="space-y-1.5">
            <label className="text-xs font-medium text-[#363062] flex items-center gap-1.5">
              <FaTools className="text-xs" />
              Type of Work
            </label>
            <Select
              options={options}
              className="text-xs"
              onChange={(e) => handleSelect(e, "workPermitType")}
              value={options.find(
                (option) => option.value === formData.workPermitType
              )}
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "35px",
                  border: "1px solid #e5e7eb",
                  boxShadow: "none",
                  borderRadius: "6px",
                  "&:hover": {
                    border: "1px solid #363062",
                  },
                }),
                valueContainer: (base) => ({
                  ...base,
                  padding: "0 8px",
                }),
                input: (base) => ({
                  ...base,
                  margin: "0px",
                }),
                option: (base, state) => ({
                  ...base,
                  fontSize: "0.75rem",
                  padding: "8px",
                  backgroundColor: state.isSelected
                    ? "#363062"
                    : state.isFocused
                    ? "#f3f4f6"
                    : null,
                  color: state.isSelected ? "white" : "#374151",
                }),
              }}
            />
          </div>

          {/* Description */}
          <div className="space-y-1.5">
            <label className="text-xs font-medium text-[#363062] flex items-center gap-1.5">
              <FaInfoCircle className="text-xs" />
              Description
            </label>
            <textarea
              className="w-full rounded-md bg-gray-50 border border-gray-200 p-2.5 text-xs focus:ring-1 focus:ring-[#363062] focus:border-[#363062]"
              rows={3}
              placeholder="Describe the work to be done"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
          </div>

          {/* Dates */}
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <label className="text-xs font-medium text-[#363062] flex items-center gap-1.5">
                <FaCalendarAlt className="text-xs" />
                Start Date
              </label>
              <input
                type="date"
                className="w-full rounded-md bg-gray-50 border border-gray-200 p-2 text-xs focus:ring-1 focus:ring-[#363062] focus:border-[#363062]"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
              />
            </div>
            <div className="space-y-1.5">
              <label className="text-xs font-medium text-[#363062] flex items-center gap-1.5">
                <FaClock className="text-xs" />
                Duration (Days)
              </label>
              <input
                type="number"
                className="w-full rounded-md bg-gray-50 border border-gray-200 p-2 text-xs focus:ring-1 focus:ring-[#363062] focus:border-[#363062]"
                placeholder="Number of days"
                name="duration"
                value={formData.duration}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Location */}
          {currentUser.roles.includes("user") ? (
            <div className="space-y-1.5">
              <label className="text-xs font-medium text-[#363062] flex items-center gap-1.5">
                <FaMapMarkerAlt className="text-xs" />
                Location
              </label>
              <Select
                options={identifierOptions}
                className="text-xs mb-2"
                placeholder={`Select ${getCapitalizedTerm("identifier")}`}
                onChange={(e) => handleSelect(e, "identifier")}
                value={identifierOptions.find(
                  (option) => option.value === formData.identifier
                )}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "35px",
                    border: "1px solid #e5e7eb",
                    boxShadow: "none",
                    borderRadius: "6px",
                    "&:hover": {
                      border: "1px solid #363062",
                    },
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    padding: "0 8px",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: "0px",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "0.75rem",
                    padding: "8px",
                    backgroundColor: state.isSelected
                      ? "#363062"
                      : state.isFocused
                      ? "#f3f4f6"
                      : null,
                    color: state.isSelected ? "white" : "#374151",
                  }),
                }}
              />
              {companyData?.entityType === "hoa" && (
                <input
                  type="text"
                  className="w-full rounded-md bg-gray-50 border border-gray-200 p-2 text-xs focus:ring-1 focus:ring-[#363062] focus:border-[#363062]"
                  placeholder="Enter street name"
                  name="streetName"
                  value={formData.streetName}
                  onChange={handleChange}
                  required
                />
              )}
            </div>
          ) : (
            <div className="flex flex-col gap-2">
              <InputBox
                label={unitNumberLabel}
                value={formData.identifier}
                disabled={false}
                onChange={handleChange}
                name="identifier"
                placeholder={`Enter ${getCapitalizedTerm("identifier")}`}
              />
            </div>
          )}

          {/* Workers */}
          <div className="space-y-1.5">
            <label className="text-xs font-medium text-[#363062] flex items-center gap-1.5">
              <FaUsers className="text-xs" />
              Workers Information
            </label>
            <textarea
              className="w-full rounded-md bg-gray-50 border border-gray-200 p-2.5 text-xs focus:ring-1 focus:ring-[#363062] focus:border-[#363062]"
              rows={3}
              placeholder="List workers' names and contact information"
              name="workers"
              value={formData.workers}
              onChange={handleChange}
            />
          </div>

          {/* Vehicle */}
          <div className="space-y-1.5">
            <label className="text-xs font-medium text-[#363062] flex items-center gap-1.5">
              <FaCarAlt className="text-xs" />
              Vehicle Information
            </label>
            <input
              type="text"
              className="w-full rounded-md bg-gray-50 border border-gray-200 p-2 text-xs focus:ring-1 focus:ring-[#363062] focus:border-[#363062]"
              placeholder="Vehicle type and plate number"
              name="vehicle"
              value={formData.vehicle}
              onChange={handleChange}
            />
          </div>

          {/* Required Documents */}
          {(formData.workPermitType === "major renovation" ||
            formData.workPermitType === "minor renovation") && (
            <div className="space-y-3">
              <h3 className="text-xs font-medium text-[#363062] flex items-center gap-1.5">
                <FaFileAlt className="text-xs" />
                Required Documents
              </h3>

              {formData.workPermitType === "major renovation" ||
                (formData.workPermitType === "major renovation" && (
                  <div className="space-y-2">
                    <div className="bg-gray-50 rounded-md p-3">
                      <FileUploadAndView
                        doc="Renovation Plan"
                        files={files}
                        handleUpload={handleUpload}
                        progress={progress}
                        activeUpload={activeUpload}
                      />
                    </div>
                    <div className="bg-gray-50 rounded-md p-3">
                      <FileUploadAndView
                        doc="Renovation Permit"
                        files={files}
                        handleUpload={handleUpload}
                        progress={progress}
                        activeUpload={activeUpload}
                      />
                    </div>
                  </div>
                ))}

              {/* {formData.workPermitType === "construction" && (
                <div className="space-y-2">
                  <div className="bg-gray-50 rounded-md p-3">
                    <FileUploadAndView
                      doc="Construction Plans"
                      files={files}
                      handleUpload={handleUpload}
                      progress={progress}
                      activeUpload={activeUpload}
                    />
                  </div>
                  <div className="bg-gray-50 rounded-md p-3">
                    <FileUploadAndView
                      doc="Construction Permit"
                      files={files}
                      handleUpload={handleUpload}
                      progress={progress}
                      activeUpload={activeUpload}
                    />
                  </div>
                  <div className="bg-gray-50 rounded-md p-3">
                    <FileUploadAndView
                      doc="Building Permit"
                      files={files}
                      handleUpload={handleUpload}
                      progress={progress}
                      activeUpload={activeUpload}
                    />
                  </div>
                </div>
              )} */}
            </div>
          )}

          {/* Bonds and Fees */}
          {(formData.workPermitType === "minor renovation" ||
            formData.workPermitType === "major renovation") && (
            <div className="space-y-3">
              <h3 className="text-xs font-medium text-[#363062] flex items-center gap-1.5">
                <FaMoneyBillWave className="text-xs" />
                Required Bonds and Fees
              </h3>

              <div className="space-y-2">
                {formData.workPermitType === "minor renovation" && (
                  <>
                    <div className="flex items-center justify-between bg-gray-50 p-2.5 rounded-md">
                      <span className="text-xs">Construction Bond</span>
                      <span className="text-xs font-medium">Php 15,000</span>
                    </div>
                    <div className="flex items-center justify-between bg-gray-50 p-2.5 rounded-md">
                      <span className="text-xs">Permit Fee</span>
                      <span className="text-xs font-medium">Php 1,500</span>
                    </div>
                  </>
                )}

                {formData.workPermitType === "major renovation" && (
                  <>
                    <div className="flex items-center justify-between bg-gray-50 p-2.5 rounded-md">
                      <span className="text-xs">Construction Bond</span>
                      <span className="text-xs font-medium">Php 30,000</span>
                    </div>
                    <div className="flex items-center justify-between bg-gray-50 p-2.5 rounded-md">
                      <span className="text-xs">Permit Fee</span>
                      <span className="text-xs font-medium">Php 3,500</span>
                    </div>
                  </>
                )}

                {/* {formData.workPermitType === "construction" && (
                    <>
                      <div className="flex items-center justify-between bg-gray-50 p-2.5 rounded-md">
                        <span className="text-xs">Construction Bond</span>
                        <span className="text-xs font-medium">Php 100,000</span>
                      </div>
                      <div className="flex items-center justify-between bg-gray-50 p-2.5 rounded-md">
                        <span className="text-xs">Sanitation Bond</span>
                        <span className="text-xs font-medium">Php 10,000</span>
                      </div>
                      <div className="flex items-center justify-between bg-gray-50 p-2.5 rounded-md">
                        <span className="text-xs">
                          Electrical Distribution Fee
                        </span>
                        <span className="text-xs font-medium">Php 20,000</span>
                      </div>
                      <div className="flex items-center justify-between bg-gray-50 p-2.5 rounded-md">
                        <span className="text-xs">
                          Water System Connection Fee
                        </span>
                        <span className="text-xs font-medium">Php 100,000</span>
                      </div>
                    </>
                  )} */}

                <div className="bg-gray-50 rounded-md p-3 mt-3">
                  <FileUploadAndView
                    doc="Bond Payment"
                    files={files}
                    handleUpload={handleUpload}
                    progress={progress}
                    activeUpload={activeUpload}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Bottom Navigation */}
        <div className="mt-4">
          <div className="max-w-md mx-auto">
            <button
              onClick={handleSubmit}
              disabled={isProcessing}
              className="w-full bg-[#363062] text-white py-3 rounded-md text-xs font-medium shadow-lg flex items-center justify-center gap-2 hover:bg-[#2d2850] transition-colors"
            >
              {isProcessing ? (
                <>
                  <svg
                    className="animate-spin h-3.5 w-3.5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Processing...
                </>
              ) : (
                <>
                  <FaPaperPlane className="text-xs" />
                  Submit Application
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </UserScreenWindow>
  );
}

export default WorkPermitUser;
